
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"100","viewBox":"0 0 100 100","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M50 0C22.39 0 0 22.384 0 50.004c0 27.62 22.39 50.004 50 50.004 27.618 0 50-22.392 50-50.004C100 22.384 77.618 0 50 0zm20.695 87.7H56.73l-6.812-11.713L43.055 87.7H29.09l13.8-18.42-13.8-18.422h13.965l6.856 10.56 6.811-10.56h13.965l-13.794 18.42L70.695 87.7zm.453-38.76H57.183l-6.819-11.712-6.856 11.712H29.543l13.802-18.42-13.802-18.428h13.965l6.856 10.56 6.82-10.56h13.964L57.347 30.52l13.801 18.42z","fill":"#000"}})])
          )
        }
      }
    